// extracted by mini-css-extract-plugin
module.exports = {"paper":"BasicChart_paper__1YuGn"};